/**
 * What the list view's outcome lines share between the market row and the fixture row:
 * the two draw different labels but are the same control, and have to line up.
 */

/** The outcome column, identical on every row, so the cells before it never shift. */
export const OUTCOME_LINES_WIDTH = 'w-[280px]'


/** Three lines and their gaps: the fixture column's height, so a two-sided fixture's
    row is as tall as a soccer row's three sides. */
export const OUTCOME_LINES_MIN_HEIGHT = 'min-h-[100px]'
